import { axios } from '@Root/API'

export const get = id => {
	return axios.get(`cost-centre-module/${id}`)
}
